export const makeDate = val => {
    const monthMap = {
        'JAN': 0,
        'FEB': 1,
        'MAR': 2,
        'APR': 3,
        'MAY': 4,
        'JUN': 5,
        'JUL': 6,
        'AUG': 7,
        'SEP': 8,
        'OCT': 9,
        'NOV': 10,
        'DEC': 11
    };
    const [dd, MM, yy] = val.split('-');
    return new Date('20' + yy, monthMap[MM], dd);
}